// extracted by mini-css-extract-plugin
module.exports = {"incidentVisual":"ClaimCapture_incidentVisual__2t9qY","incidentClassCon":"ClaimCapture_incidentClassCon__1c0aA"};